import { type TileIndex } from "@/types/tile";
import { FrameName } from "../config";
import TileEntity from "../TileEntity";

class PumpkinFieldBuildingTileEntity extends TileEntity {
	public static readonly frameName = FrameName.PUMPKIN_FIELD;

	public get suppliesTileIndexes(): Set<TileIndex> {
		return new Set<TileIndex>(
			// zasobuje len 1 farmu
			Array.from(super.suppliesTileIndexes).slice(0, 1),
		);
	}
}

export default PumpkinFieldBuildingTileEntity;
